import { render, staticRenderFns } from "./BaseArray.vue?vue&type=template&id=685a1e7a"
import script from "./BaseArray.vue?vue&type=script&lang=js"
export * from "./BaseArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports